__turbopack_context__.v({
  "safetySection": "safety-section-module-scss-module__4tjieW__safetySection",
  "safetySection_description": "safety-section-module-scss-module__4tjieW__safetySection_description",
  "safetySection_featureIcon": "safety-section-module-scss-module__4tjieW__safetySection_featureIcon",
  "safetySection_featureItem": "safety-section-module-scss-module__4tjieW__safetySection_featureItem",
  "safetySection_featuresList": "safety-section-module-scss-module__4tjieW__safetySection_featuresList",
  "safetySection_main": "safety-section-module-scss-module__4tjieW__safetySection_main",
  "safetySection_process": "safety-section-module-scss-module__4tjieW__safetySection_process",
  "safetySection_processActions": "safety-section-module-scss-module__4tjieW__safetySection_processActions",
  "safetySection_processItem": "safety-section-module-scss-module__4tjieW__safetySection_processItem",
  "safetySection_processList": "safety-section-module-scss-module__4tjieW__safetySection_processList",
  "safetySection_processMarker": "safety-section-module-scss-module__4tjieW__safetySection_processMarker",
  "safetySection_processTitle": "safety-section-module-scss-module__4tjieW__safetySection_processTitle",
});
